import CommonLang from "./common.lang";
import LoginLang from "./login.lang";
import NotFoundLang from "./not-found.lang";
import HomeLang from "./home.lang";
import HomeConversationLang from "./home-conversation.lang";
import CallingLang from "./calling.lang";
import FileLang from "./file.lang";
import ScreenLockLang from "./screen-lock.lang";
import RingLang from "./ring.lang";
import UpgradeVersionLang from "./upgrade-version.lang";
import SettingNotification from "./setting-notification";
import CheckNetwork from "./check-network";

export default {
  common: CommonLang,
  login: LoginLang,
  notFound: NotFoundLang,
  home: HomeLang,
  homeConversation: HomeConversationLang,
  callingLang: CallingLang,
  file: FileLang,
  screenLock: ScreenLockLang,
  ring: RingLang,
  upgradeVersion: UpgradeVersionLang,
  settingNotification: SettingNotification,
  checkNetwork: CheckNetwork,
};
